module.exports = __webpack_public_path__ + "mobile/img/huiVisitors-img3.21b32f10.png";